<script context="module">
  export const i18n = {
    sv: {
      'the homepage': 'startsidan',
      'Something’s wrong': 'Något gick fel',
      'Page not found': 'Sidan kunde inte hittas',
      'Order not found': 'Ordern kunde inte hittas',
      "Are you looking for something that isn't here?":
        'Letar du efter något som inte finns här?',
      'Try finding your way from %s.': 'Försök hitta rätt från %s.',
      'We are currently experiencing issues with our systems.':
        'Vi upplever för närvarande problem med våra system.',
      'If the problem persists, please contact us at %s':
        'Om problemet kvarstår, kontakta oss på %s'
    },
    da: {
      'the homepage': 'forsiden',
      'Something’s wrong': 'Noget gik galt',
      'Page not found': 'Siden blev ikke fundet',
      'Order not found': 'Ordren blev ikke fundet',
      "Are you looking for something that isn't here?":
        'Leder du efter noget, der ikke er her?',
      'Try finding your way from %s.': 'Forsøg at finde den rigtige fra %s.',
      'We are currently experiencing issues with our systems.':
        'Vi oplever i øjeblikket problemer med vores systemer.',
      'If the problem persists, please contact us at %s':
        'Hvis problemet fortsætter, bedes du kontakte os på %s'
    }
  }
</script>

<script>
  import { dev } from '$app/environment'
  import { page } from '$app/stores'

  import PageHeading from '$lib/PageHeading.svelte'
  import { prefix } from '$lib/utils/prefix.js'
  import { register, text } from '$lib/text.js'
  import { setMeta } from '$lib/Meta.svelte'
  import Header from '$lib/Header.svelte'
  import Footer from '$lib/Footer.svelte'

  register(i18n)

  $: setMeta({
    title: $text($page.error?.message || 'Something’s wrong')
  })
</script>

<div class="error">
  <Header>
    <svelte:fragment slot="primary">
      {#if $page.data.agent?.settings?.data.logotype?.url}
        <img
          class="logotype"
          src={$page.data.agent.settings.data.logotype.url}
          alt={$page.data.agent.settings.data.name} />
      {:else if $page.data.agent?.settings?.data.name}
        {$page.data.agent.settings.data.name}
      {/if}
    </svelte:fragment>
  </Header>

  <div class="content u-container">
    <PageHeading
      title={$page.status === 404
        ? $text`Page not found`
        : $text($page.error?.message || 'Something’s wrong')}>
      <slot name="body" slot="body" error={$page.error}>
        {#if dev}
          <pre>{JSON.stringify($page.error, null, 2)}</pre>
        {/if}
        {#if $page.status === 404}
          <p>
            {$text`Are you looking for something that isn't here?`}
            <br />
            <span>
              {@html $text`Try finding your way from ${`<a href="${$prefix}/">${$text`the homepage`}</a>`}.`}
            </span>
          </p>
        {:else}
          <p>
            {$text`We are currently experiencing issues with our systems.`}
            <br />
            {@html $text`If the problem persists, please contact us at ${`<a class="u-nowrap" href="mailto:support@allaboard.eu">support@allaboard.eu</a>`}.`}
          </p>
        {/if}
      </slot>
    </PageHeading>
  </div>

  <div class="footer">
    <Footer />
  </div>
</div>

<style>
  .error {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .logotype {
    display: block;
    width: auto;
    height: 2.75rem;
  }

  .content {
    display: grid;
    align-items: center;
    min-height: 65vh;
    padding: clamp(1vh, 5rem, 5vh) 0 10vh;
  }

  .footer {
    margin-top: auto;
  }
</style>
